import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { useCalendarContext } from '../../context/calendarProvider.mjs';
import { DateItemWrapper, EventDot, DayText, DateCircle } from './styled.mjs';

var DateItem = function DateItem(_ref) {
  var date = _ref.date,
    isSelected = _ref.isSelected,
    hasEvent = _ref.hasEvent,
    userLocale = _ref.userLocale;
  var _useCalendarContext = useCalendarContext(),
    setSelectedDateValue = _useCalendarContext.setSelectedDateValue;
  var dateFormatter = React__default.useMemo(function () {
    return new Intl.DateTimeFormat(userLocale, {
      weekday: "narrow"
    });
  }, [userLocale]);
  // 요일 문자열 메모이제이션
  var dayText = React__default.useMemo(function () {
    return dateFormatter.format(date);
  }, [date, dateFormatter]);
  var handleClick = React__default.useCallback(function (e) {
    setSelectedDateValue(date.valueOf());
    e.currentTarget.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    });
  }, [date, setSelectedDateValue]);
  return jsxs(DateItemWrapper, {
    "$isSelected": isSelected,
    onClick: handleClick,
    children: [jsx(EventDot, {
      "$show": hasEvent
    }), jsx(DayText, {
      children: dayText
    }), jsx(DateCircle, {
      "$isSelected": isSelected,
      children: date.getDate()
    })]
  });
};

export { DateItem };
